import React, { Component, useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Grid, TextField, Button, CircularProgress, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Box, Chip, Tooltip, DialogActions, RadioGroup, FormControlLabel, Radio, Autocomplete } from '@mui/material';
import { IoMdCloseCircleOutline } from "react-icons/io";
import { DataTable, DatePicker, FontIcon, TableBody, TableColumn, TableHeader, TimePicker } from 'react-md';
import Toggle from 'react-toggle';
import TextEditor from '../../../component/TextEditor';
import { MdDragIndicator } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BsInfoCircleFill } from "react-icons/bs";
import { PiCaretUpBold, PiCaretDownBold } from "react-icons/pi";
import { IoIosCloseCircle } from "react-icons/io";
import ApiRequestService from '../../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import { DEFAULT_AT_FIRST, DEFAULT_AT_LAST, DEFAULT_MASTERY_COUNT, DEFAULT_NOCQC, DEFAULT_RADNOM_SUBCATEGORY_ORDER, DEFAULT_REQUIRED, MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST } from '../Constants';
import CategoryOptionsModal from './CategoryOptionsModal';
import { AppProperties } from '../../../common/function';
import HelpText from '../../../lib/help-text';
import EditWindow from '../../EditWindow';
import CollapsableColumn from '../../../component/CollapsableColumn';
import { TableRow as TableRowReact } from 'react-md';
import editIcon from '../../../images/png/edit.png';
import crossIcon from '../../../images/png/crossIcon.png';
import SubjectTopicCategorySelect from '../SubjectTopicCategorySelect';
import { IoLink } from 'react-icons/io5';

const SectionSubsectionDialog = ({
    showDialog,
    handleClose,
    selectedSectionAndSubsectionList,
    sections,
    subSections,
    onSaveSectionSubsection,
    onDeleteSectionSubsection
}) => {

    const [showAddSubsection, setShowSubsection] = useState(false);
    const [selectedSection, setSelectedSection] = useState(null);
    const [editMode, setEditMode] = useState(false);
    return (
        <Dialog
            open={showDialog}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}>
                <Typography fontSize={18} fontWeight={500}>
                    Sections & Subsections Table
                </Typography>
                <Button
                    style={{
                        marginRight: "2rem"
                    }}
                    variant='contained' onClick={() => {
                        setEditMode(false);
                        setShowSubsection(true);
                    }}>
                    Add Section & Subsection
                </Button>
            </DialogTitle>

            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>

            <DialogContent>
                <DataTable plain baseId="simple-pagination">
                    <TableHeader>
                        <TableRowReact>
                            <TableColumn className="SectionWidgetHeaderStyle">
                                Sections
                            </TableColumn>
                            <TableColumn className="SectionWidgetHeaderStyle">
                                SubSections
                            </TableColumn>
                            <TableColumn className="SectionWidgetHeaderStyle">
                                Actions
                            </TableColumn>
                        </TableRowReact>
                    </TableHeader>
                    <TableBody>
                        {selectedSectionAndSubsectionList?.map((rowData, index) => {
                            //console.debug("rowData>>??", rowData)
                            return (
                                <TableRowReact
                                    key={index}
                                    selectable={false} >
                                    <TableColumn className="quizTableColumn">
                                        {rowData.section_name}
                                    </TableColumn>

                                    {rowData.subsection?.length > 1 ? <CollapsableColumn
                                        data={rowData.subsection}
                                        className="quizTableColumn"
                                    >
                                    </CollapsableColumn> :
                                        <TableColumn className="quizTableColumn">
                                            {rowData.subsection ? rowData.subsection[0] : null}
                                        </TableColumn>}
                                    <TableColumn className="quizTableColumn">
                                        <Button icon tooltipLabel="Edit">
                                            <img src={editIcon} alt="Edit"
                                                onClick={() => {
                                                    setEditMode(true);
                                                    setSelectedSection(rowData);
                                                    setShowSubsection(true);
                                                }}
                                            />
                                        </Button> {'  '}
                                        <Button icon tooltipLabel="Delete"
                                            onClick={() => {
                                                onDeleteSectionSubsection(index);
                                            }}
                                        >
                                            <img src={crossIcon} alt="Delete" />
                                        </Button>
                                    </TableColumn>
                                </TableRowReact>
                            )
                        })}
                    </TableBody>
                </DataTable>
            </DialogContent>

            {showAddSubsection ?
                <AddSubsectionDialog
                    showDialog={true}
                    sections={sections}
                    subSections={subSections}
                    handleClose={() => {
                        setEditMode(false);
                        setSelectedSection(null);
                        setShowSubsection(false);
                    }}
                    selectedSectionAndSubsectionList={selectedSectionAndSubsectionList}
                    selectedSection={selectedSection}
                    editMode={editMode}
                    onSaveSectionSubsection={onSaveSectionSubsection}
                />
                : null}

        </Dialog>
    )
}

const AddSubsectionDialog = ({
    showDialog,
    handleClose,
    sections,
    subSections,
    selectedSection,
    editMode,
    selectedSectionAndSubsectionList,
    onSaveSectionSubsection
}) => {

    const [selectedSectionID, setSelectedSectionID] = useState(null);
    const [selectedSubsectionIDArr, setSelectedSubsectionIDArr] = useState([]);
    const [subSectionList, setSubSectionList] = useState([]);

    useEffect(() => {
        if (editMode) {
            setSelectedSectionID(selectedSection.section_id);
            setSelectedSubsectionIDArr(selectedSection.subsectionList.map(subSec => subSec.subsection_id));
            setSubSectionList(subSections.filter(subSec => subSec.section_id === selectedSection.section_id));
        }
    }, [])


    const handleSaveSectionSubsection = () => {
        console.debug("selected>>??", selectedSectionID, selectedSubsectionIDArr)
        const section = sections.find(sec => sec.section_id === selectedSectionID);
        let data = {}
        let selecetedSubSections = subSectionList.filter(subSec => selectedSubsectionIDArr.includes(subSec.subsection_id));
        //console.debug("selecetedSubSections>>??", selecetedSubSections)
        if (section) {
            data = {
                section_id: selectedSectionID,
                section_name: section.section_name,
                subsectionList: selecetedSubSections,
                subsection: selecetedSubSections.map(subsection => subsection.subsection_name)
            }
        }

        let checkIfSectionIsAlreadyAddedIndex = selectedSectionAndSubsectionList.findIndex(sec => sec.section_id === data.section_id);
        if (checkIfSectionIsAlreadyAddedIndex > -1 && !editMode) {
            NotificationManager.error("This section is already added, please add new section or edit the section to add more subsection");
        } else {
            onSaveSectionSubsection(data, editMode, selectedSection);
            handleClose();
        }
    }

    return (
        <Dialog
            open={showDialog}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={500}>
                    {editMode ? "Edit" : "Add"} Subsection
                </Typography>
            </DialogTitle>

            <DialogContent>
                <FormControl fullWidth variant="outlined" size="small" margin="dense">
                    <InputLabel id="id-section-label">Section</InputLabel>
                    <Select
                        id="id-section"
                        labelId="id-section-label"
                        label="Section"
                        value={selectedSectionID}
                        onChange={(e) => {
                            const value = e.target.value;
                            let filteredSubSections = subSections.filter(subSec => {
                                return subSec.section_id === value;
                            });
                            //console.debug("filteredSubSections>>??", filteredSubSections)
                            setSelectedSectionID(value);
                            setSubSectionList(filteredSubSections || []);
                            setSelectedSubsectionIDArr([]);
                        }}
                    >
                        {sections?.map((section, index) => (
                            <MenuItem key={index} value={section.section_id}>
                                {section.section_name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {selectedSectionID && (
                    <FormControl fullWidth variant="outlined" size="small" margin="dense">
                        <InputLabel id="id-sub-section-label">Subsection</InputLabel>
                        <Select
                            labelId="id-sub-section-label"
                            id="id-sub-section"
                            label="Subsection"
                            multiple
                            value={selectedSubsectionIDArr}
                            onChange={(e) => {
                                setSelectedSubsectionIDArr(e.target.value)
                            }}
                        >
                            {subSectionList?.map((subSection, index) => (
                                <MenuItem key={index} value={subSection.subsection_id}>
                                    {subSection.subsection_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="contained"
                    disabled={selectedSectionID === null || selectedSubsectionIDArr.length === 0}
                    onClick={handleSaveSectionSubsection}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>

    )
}

export default SectionSubsectionDialog;